import { useState, useEffect } from 'react'
import useCreateStore from '../../lib/useCreateStore'
import estateActions from './actions'
import estateSelectors from './selectors'

// Store para armazenar os dados do imóvel selecionado pelo usuário

const initialState = {
  num: 0,
  sample: {
    teste: '',
    num: 0,
  },
}

const EstateStore = useCreateStore(() => {
  const [$estate, setEstate] = useState(initialState)
  const actions = estateActions(setEstate)
  const selectors = estateSelectors($estate)

  useEffect(() => {}, [])

  return { $estate, ...actions, ...selectors }
})

export const useEstate = () => EstateStore()
export const EstateContext = EstateStore.Context
export const EstateProvider = EstateStore.Provider
